import MainView from '@/views/MainView'
import View from '@/views/View'

// 备货
const stockupRouter = [
  {
    path: 'stockupcheck',
    name: 'stockupcheck',
    meta: { title: '备货审批' },
    component: () => import('@/views/workbench/workCheckView/stockCheckView/stockCheckView')
  },
  {
    path: 'stockupcheckdetail',
    name: 'stockupcheckdetail',
    meta: { title: '备货审批详情' },
    component: () => import('@/views/workbench/workCheckView/stockCheckView/stockCheckDetail')
  }
]

// 采购
const poRouter = [
  {
    path: 'polackcheck',
    name: 'polackcheck',
    meta: { title: '采购报缺审批' },
    component: () => import('@/views/workbench/workCheckView/poLackCheckView/poLackCheckView')
  },
  {
    path: 'polackcheckdetail',
    name: 'polackcheckdetail',
    meta: { title: '采购报缺审批详情' },
    component: () => import('@/views/workbench/workCheckView/poLackCheckView/poLackCheckDetail')
  },
  {
    path: 'popaycheck',
    name: 'popaycheck',
    meta: { title: '采购付款审批' },
    component: () => import('@/views/workbench/workCheckView/poPayCheckView/poPayCheckView')
  },
  {
    path: 'popaycheckdetail',
    name: 'popaycheckdetail',
    meta: { title: '采购付款审批详情' },
    component: () => import('@/views/workbench/workCheckView/poPayCheckView/poPayCheckDetail')
  },
  {
    path: 'popactcheck',
    name: 'popactcheck',
    meta: { title: '采购合同审批' },
    component: () => import('@/views/workbench/workCheckView/poPactCheckView/poPactCheckView')
  }, {
    path: 'popactcheckdetail',
    name: 'popactcheckdetail',
    meta: { title: '采购合同审批详情' },
    component: () => import('@/views/workbench/workCheckView/poPactCheckView/poPactCheckDetail')
  },
  {
    path: 'popactsealcheck',
    name: 'popactsealcheck',
    meta: { title: '采购合同盖章审批' },
    component: () => import('@/views/workbench/workCheckView/poPactCheckView/poPactsealCheckView')
  }, {
    path: 'popactsealcheckdetail',
    name: 'popactsealcheckdetail',
    meta: { title: '采购合同盖章审批详情' },
    component: () => import('@/views/workbench/workCheckView/poPactCheckView/poPactsealCheckDetail')
  }
]

// 采购退货
const poreturncheckRouter = [{
  path: 'poreturncheck',
  name: 'poreturncheck',
  meta: { title: '采购退货审批' },
  component: () => import('@/views/workbench/workCheckView/poreturnCheckView/poreturnCheckView')
}, {
  path: 'poreturncheckdetail',
  name: 'poreturncheckdetail',
  meta: { title: '采购退货审批详情' },
  component: () => import('@/views/workbench/workCheckView/poreturnCheckView/poreturnCheckDetail')
}, {
  path: 'porefundscheck',
  name: 'porefundscheck',
  meta: { title: '采购退货收款审批' },
  component: () => import('@/views/workbench/workCheckView/porefundsCheckView/porefundsCheckView')
}, {
  path: 'porefundscheckdetail',
  name: 'porefundscheckdetail',
  meta: { title: '采购退货收款审批详情' },
  component: () => import('@/views/workbench/workCheckView/porefundsCheckView/porefundsCheckDetail')
}, {
  path: 'poreturncontractcheck',
  name: 'poreturncontractcheck',
  meta: { title: '采购退货合同审批' },
  component: () => import('@/views/workbench/workCheckView/poreturncontractCheckView/poreturncontractCheckView')
}, {
  path: 'poreturncontractcheckdetail',
  name: 'poreturncontractcheckdetail',
  meta: { title: '采购退货合同审批详情' },
  component: () => import('@/views/workbench/workCheckView/poreturncontractCheckView/poreturncontractCheckDetail')
}]

// 特价
const specialofferRouter = [{
  path: 'specialoffercheck',
  name: 'specialoffercheck',
  meta: { title: '特价审批' },
  component: () => import('@/views/workbench/workCheckView/specialofferCheckView/specialofferCheckView')
}, {
  path: 'specialoffercheckdetail',
  name: 'specialoffercheckdetail',
  meta: { title: '特价审批详情' },
  component: () => import('@/views/workbench/workCheckView/specialofferCheckView/specialofferCheckDetail')
}, {
  path: 'specialofferlimitcheck',
  name: 'specialofferlimitcheck',
  meta: { title: '特价限制审批' },
  component: () => import('@/views/workbench/workCheckView/specialofferCheckView/specialofferLimitCheckView')
}, {
  path: 'specialofferlimitcheckdetail',
  name: 'specialofferlimitcheckdetail',
  meta: { title: '特价限制审批详情' },
  component: () => import('@/views/workbench/workCheckView/specialofferCheckView/specialofferLimitCheckDetail')
}]

// 报价
const makeofferRouter = [{
  path: 'makeoffercheck',
  name: 'makeoffercheck',
  meta: { title: '报价审批' },
  component: () => import('@/views/workbench/workCheckView/makeofferCheckView/makeofferCheckView')
}, {
  path: 'makeoffercheckdetail',
  name: 'makeoffercheckdetail',
  meta: { title: '报价审批详情' },
  component: () => import('@/views/workbench/workCheckView/makeofferCheckView/makeofferCheckDetail')
}]

// 销售合同
const sellpactRouter = [{
  path: 'sellpactcheck',
  name: 'sellpactcheck',
  meta: { title: '销售合同审批' },
  component: () => import('@/views/workbench/workCheckView/sellpactCheckView/sellpactCheckView')
}, {
  path: 'sellpactcheckdetail',
  name: 'sellpactcheckdetail',
  meta: { title: '销售合同审批详情' },
  component: () => import('@/views/workbench/workCheckView/sellpactCheckView/sellpactCheckDetail')
}, {
  path: 'sellpactsealcheck',
  name: 'sellpactsealcheck',
  meta: { title: '销售合同盖章审批' },
  component: () => import('@/views/workbench/workCheckView/sellpactCheckView/sellpactsealCheckView')
}, {
  path: 'sellpactsealcheckdetail',
  name: 'sellpactsealcheckdetail',
  meta: { title: '销售合同盖章审批详情' },
  component: () => import('@/views/workbench/workCheckView/sellpactCheckView/sellpactsealCheckDetail')
},
// {
//   path: 'salereturncontractcheck',
//   name: 'salereturncontractcheck',
//   meta: { title: '销售合同退货审批' },
//   component: () => import('@/views/workbench/workCheckView/salereturncontractCheckView/salereturncontractCheckView')
// }, {
//   path: 'salereturncontractcheckdetail',
//   name: 'salereturncontractcheckdetail',
//   meta: { title: '销售合同退货审批详情' },
//   component: () => import('@/views/workbench/workCheckView/salereturncontractCheckView/salereturncontractCheckDetail')
// },

{
  path: 'salereturncontractcheck',
  name: 'salereturncontractcheck',
  meta: { title: '销售退货合同盖章审批' },
  component: () => import('@/views/workbench/workCheckView/salesreturnCheckView/sellreturnpactsealCheckView')
}, {
  path: 'salereturncontractcheckdetail',
  name: 'salereturncontractcheckdetail',
  meta: { title: '销售退货合同盖章审批详情' },
  component: () => import('@/views/workbench/workCheckView/salesreturnCheckView/sellreturnpactsealCheckDetail')
}]

// 释放库存
const releaseitoryRouter = [{
  path: 'releaseitorycheck',
  name: 'releaseitorycheck',
  meta: { title: '释放库存审批' },
  component: () => import('@/views/workbench/workCheckView/releaseitoryCheckView/releaseitoryCheckView')
}, {
  path: 'releaseitorycheckdetail',
  name: 'releaseitorycheckdetail',
  meta: { title: '释放库存审批详情' },
  component: () => import('@/views/workbench/workCheckView/releaseitoryCheckView/releaseitoryCheckDetail')
}]

// 发货审批
const deliverRouter = [{
  path: 'delivercheck',
  name: 'delivercheck',
  meta: { title: '发货审批' },
  component: () => import('@/views/workbench/workCheckView/deliverCheckView/deliverCheckView')
}, {
  path: 'delivercheckdetail',
  name: 'delivercheckdetail',
  meta: { title: '发货审批详情' },
  component: () => import('@/views/workbench/workCheckView/deliverCheckView/deliverCheckDetail')
}]

// 销售报缺审批
const selllackRouter = [{
  path: 'selllackcheck',
  name: 'sellLackcheck',
  meta: { title: '销售报缺审批' },
  component: () => import('@/views/workbench/workCheckView/sellLackCheckView/sellLackCheckView')
}, {
  path: 'selllackcheckdetail',
  name: 'selllackcheckdetail',
  meta: { title: '销售报缺审批详情' },
  component: () => import('@/views/workbench/workCheckView/sellLackCheckView/sellLackCheckDetail')
}]

// 坏账审批
const baddebtRouter = [{
  path: 'baddebtcheck',
  name: 'baddebtcheck',
  meta: { title: '坏账审批' },
  component: () => import('@/views/workbench/workCheckView/baddebtCheckView/baddebtCheckView')
}, {
  path: 'baddebtcheckdetail',
  name: 'baddebtcheckdetail',
  meta: { title: '坏账审批详情' },
  component: () => import('@/views/workbench/workCheckView/baddebtCheckView/baddebtCheckDetail')
}]

// 开票审批
const makeinvoiceRouter = [{
  path: 'makeinvoicecheck',
  name: 'makeinvoicecheck',
  meta: { title: '开票审批' },
  component: () => import('@/views/workbench/workCheckView/makeinvoiceCheckView/makeinvoiceCheckView')
}, {
  path: 'makeinvoicecheckdetail',
  name: 'makeinvoicecheckdetail',
  meta: { title: '开票审批详情' },
  component: () => import('@/views/workbench/workCheckView/makeinvoiceCheckView/makeinvoiceCheckDetail')
}, {
  path: 'finemakeinvoicecheck',
  name: 'finemakeinvoicecheck',
  meta: { title: '罚没金开票审批' },
  component: () => import('@/views/workbench/workCheckView/makeinvoiceCheckView/fineMakeinvoiceCheckView')
}, {
  path: 'finemakeinvoicecheckdetail',
  name: 'finemakeinvoicecheckdetail',
  meta: { title: '罚没金开票审批详情' },
  component: () => import('@/views/workbench/workCheckView/makeinvoiceCheckView/fineMakeinvoiceCheckDetail')
}]

// 维修费用结算审批
const maintaincostRouter = [{
  path: 'maintaincostcheck',
  name: 'maintaincostcheck',
  meta: { title: '维修费用结算审批' },
  component: () => import('@/views/workbench/workCheckView/maintaincostCheckView/maintaincostCheckView')
}, {
  path: 'maintaincostcheckdetail',
  name: 'maintaincostcheckdetail',
  meta: { title: '维修费用结算审批详情' },
  component: () => import('@/views/workbench/workCheckView/maintaincostCheckView/maintaincostCheckDetail')
}]

// 退货审批
const salesreturnRouter = [{
  path: 'salesreturncheck',
  name: 'salesreturncheck',
  meta: { title: '销售退货审批' },
  component: () => import('@/views/workbench/workCheckView/salesreturnCheckView/salesreturnCheckView')
}, {
  path: 'salesreturncheckdetail',
  name: 'salesreturncheckdetail',
  meta: { title: '销售退货审批详情' },
  component: () => import('@/views/workbench/workCheckView/salesreturnCheckView/salesreturnCheckDetail')
}, {
  path: 'returnplancheck',
  name: 'returnplancheck',
  meta: { title: '销售退货结算方案审批' },
  component: () => import('@/views/workbench/workCheckView/returnplanCheckView/returnplanCheckView')
}, {
  path: 'returnplancheckdetail',
  name: 'returnplancheckdetail',
  meta: { title: '销售退货结算方案审批详情' },
  component: () => import('@/views/workbench/workCheckView/returnplanCheckView/returnplanCheckDetail')
}]

// 退货超限审批
const returnoverlimltRouter = [{
  path: 'returnoverlimltcheck',
  name: 'returnoverlimltcheck',
  meta: { title: '退货超限审批' },
  component: () => import('@/views/workbench/workCheckView/returnOverLimltCheckView/returnOverLimltCheckView')
}, {
  path: 'returnoverlimltcheckdetail',
  name: 'returnoverlimltcheckdetail',
  meta: { title: '退货超限审批详情' },
  component: () => import('@/views/workbench/workCheckView/returnOverLimltCheckView/returnOverLimltCheckDetail')
}]

// 供应商充值审批
const supplierRechargeRouter = [{
  path: 'supplierrechargecheck',
  name: 'supplierrechargecheck',
  meta: { title: '供应商充值审批' },
  component: () => import('@/views/workbench/workCheckView/supplierrechargeCheckView/supplierrechargeCheckView')
}, {
  path: 'supplierrechargecheckdetail',
  name: 'supplierrechargecheckdetail',
  meta: { title: '供应商充值审批详情' },
  component: () => import('@/views/workbench/workCheckView/supplierrechargeCheckView/supplierrechargeCheckDetail')
}]

// 客户提现审批
const customerdepositRouter = [{
  path: 'customerdepositcheck',
  name: 'customerdepositcheck',
  meta: { title: '客户提现审批' },
  component: () => import('@/views/workbench/workCheckView/customerdepositCheckView/customerdepositCheckView')
}, {
  path: 'customerdepositcheckdetail',
  name: 'customerdepositcheckdetail',
  meta: { title: '客户提现审批详情' },
  component: () => import('@/views/workbench/workCheckView/customerdepositCheckView/customerdepositCheckDetail')
}]

// 客户关系转移审批
const customershiftRouter = [{
  path: 'customershiftcheck',
  name: 'customershiftcheck',
  meta: { title: '客户关系转移审批' },
  component: () => import('@/views/workbench/workCheckView/customershiftCheckView/customershiftCheckView')
}, {
  path: 'customershiftcheckdetail',
  name: 'customershiftcheckdetail',
  meta: { title: '客户关系转移审批详情' },
  component: () => import('@/views/workbench/workCheckView/customershiftCheckView/customershiftCheckDetail')
}]

// 星级调整审批
const starleveladjustRouter = [{
  path: 'starleveladjustcheck',
  name: 'starleveladjustcheck',
  meta: { title: '星级调整审批' },
  component: () => import('@/views/workbench/workCheckView/starleveladjustCheckView/starleveladjustCheckView')
}, {
  path: 'starleveladjustcheckdetail',
  name: 'starleveladjustcheckdetail',
  meta: { title: '星级调整审批详情' },
  component: () => import('@/views/workbench/workCheckView/starleveladjustCheckView/starleveladjustCheckDetail')
}]

// 客户提额审批
const customerliftRouter = [{
  path: 'customerliftcheck',
  name: 'customerliftcheck',
  meta: { title: '客户提额审批' },
  component: () => import('@/views/workbench/workCheckView/customerliftCheckView/customerliftCheckView')
}, {
  path: 'customerliftcheckdetail',
  name: 'customerliftcheckdetail',
  meta: { title: '客户提额审批详情' },
  component: () => import('@/views/workbench/workCheckView/customerliftCheckView/customerliftCheckDetail')
}]

// 委托人审批
const baliorRouter = [{
  path: 'updatebaliorcheck',
  name: 'updatebaliorcheck',
  meta: { title: '修改委托人审批' },
  component: () => import('@/views/workbench/workCheckView/baliorCheckView/updatebaliorCheckView')
}, {
  path: 'updatebaliorcheckdetail',
  name: 'updatebaliorcheckdetail',
  meta: { title: '修改委托人审批详情' },
  component: () => import('@/views/workbench/workCheckView/baliorCheckView/deletebaliorCheckDetail')
}, {
  path: 'deletebaliorcheck',
  name: 'deletebaliorcheck',
  meta: { title: '取消委托人审批' },
  component: () => import('@/views/workbench/workCheckView/baliorCheckView/deletebaliorCheckView')
}, {
  path: 'deletebaliorcheckdetail',
  name: 'deletebaliorcheckdetail',
  meta: { title: '取消委托人审批详情' },
  component: () => import('@/views/workbench/workCheckView/baliorCheckView/deletebaliorCheckDetail')
}]

// 客户余额调整审批
const customerbalanadjustRouter = [{
  path: 'customerbalanadjustcheck',
  name: 'customerbalanadjustcheck',
  meta: { title: '客户余额调整审批' },
  component: () => import('@/views/workbench/workCheckView/customerbalanadjustCheckView/customerbalanadjustCheckView')
}, {
  path: 'customerbalanadjustcheckdetail',
  name: 'customerbalanadjustcheckdetail',
  meta: { title: '客户余额调整审批详情' },
  component: () => import('@/views/workbench/workCheckView/customerbalanadjustCheckView/customerbalanadjustCheckDetail')
}]

// 供应商账户余额调整审批
const supplieraccountadjustRouter = [{
  path: 'supplieraccountadjustcheck',
  name: 'supplieraccountadjustcheck',
  meta: { title: '供应商账户余额调整审批' },
  component: () => import('@/views/workbench/workCheckView/supplieraccountadjustCheckView/supplieraccountadjustCheckView')
}, {
  path: 'supplieraccountadjustcheckdetail',
  name: 'supplieraccountadjustcheckdetail',
  meta: { title: '供应商账户余额调整审批详情' },
  component: () => import('@/views/workbench/workCheckView/supplieraccountadjustCheckView/supplieraccountadjustCheckDetail')
}]

// 供应商抵扣余额调整审批
const supplierdeductionadjustRouter = [{
  path: 'supplierdeductionadjustcheck',
  name: 'supplierdeductionadjustcheck',
  meta: { title: '供应商抵扣余额调整审批' },
  component: () => import('@/views/workbench/workCheckView/supplierdeductionadjustCheckView/supplierdeductionadjustCheckView')
}, {
  path: 'supplierdeductionadjustcheckdetail',
  name: 'supplierdeductionadjustcheckdetail',
  meta: { title: '供应商抵扣余额调整审批详情' },
  component: () => import('@/views/workbench/workCheckView/supplierdeductionadjustCheckView/supplierdeductionadjustCheckDetail')
}]

// 供应商活动收款审批
const supplierreceiptRouter = [{
  path: 'supplierreceiptcheck',
  name: 'supplierreceiptcheck',
  meta: { title: '供应商活动收款审批' },
  component: () => import('@/views/workbench/workCheckView/supplierreceiptCheckView/supplierreceiptCheckView')
}, {
  path: 'supplierreceiptcheckdetail',
  name: 'supplierreceiptcheckdetail',
  meta: { title: '供应商活动收款审批详情' },
  component: () => import('@/views/workbench/workCheckView/supplierreceiptCheckView/supplierreceiptCheckDetail')
}]

// 承兑汇票收款审批
const ticketreceiptRouter = [{
  path: 'ticketreceiptcheck',
  name: 'ticketreceiptcheck',
  meta: { title: '承兑汇票收款审批' },
  component: () => import('@/views/workbench/workCheckView/ticketreceiptCheckView/ticketreceiptCheckView')
}, {
  path: 'ticketreceiptcheckdetail',
  name: 'ticketreceiptcheckdetail',
  meta: { title: '承兑汇票收款审批详情' },
  component: () => import('@/views/workbench/workCheckView/ticketreceiptCheckView/ticketreceiptCheckDetail')
}]

export default {
  path: '/workbench',
  component: MainView,
  name: 'workbench',
  meta: { title: '工作台' },
  icon: 'el-icon-menu',
  redirect: '/workbench/workbenchManage/home',
  children: [
    {
      path: 'workbenchManage',
      name: 'workbenchManage',
      meta: { title: '工作台' },
      redirect: '/workbench/workbenchManage/home',
      component: View,
      children: [
        {
          path: 'test',
          name: 'test',
          meta: { title: '测试' },
          component: () => import('@/views/workbench/workbenchManage/test')
        },
        {
          path: 'home',
          name: 'home',
          meta: { title: '首页' },
          component: () => import('@/views/workbench/workbenchManage/home')
        },
        {
          path: 'notice',
          name: 'notice',
          meta: { title: '公告' },
          component: () => import('@/views/workbench/workbenchManage/notice')
        },
        {
          path: 'noticedetail',
          name: 'noticedetail',
          meta: { title: '公告详情' },
          component: () => import('@/views/workbench/workbenchManage/notice/noticeDetail')
        },
        {
          path: 'noticeadministration',
          name: 'noticeadministration',
          meta: { title: '公告管理' },
          component: () => import('@/views/workbench/workbenchManage/notice/noticeAdmininstration')
        },
        {
          path: 'noticeaddoredit',
          name: 'noticeaddoredit',
          meta: { title: '编辑公告' },
          component: () => import('@/views/workbench/workbenchManage/notice/noticeAddOrEdit')
        },
        {
          path: 'inform',
          name: 'inform',
          meta: { title: '通知' },
          component: () => import('@/views/workbench/workbenchManage/inform')
        },
        {
          path: 'backlog',
          name: 'backlog',
          meta: { title: '待办' },
          component: () => import('@/views/workbench/workbenchManage/backlog')
        },
        {
          path: 'quickarea',
          name: 'quickarea',
          meta: { title: '快捷区域' },
          component: () => import('@/views/workbench/workbenchManage/quickarea')
        },
        ...stockupRouter,
        ...poRouter,
        ...poreturncheckRouter,
        ...specialofferRouter,
        ...makeofferRouter,
        ...sellpactRouter,
        ...releaseitoryRouter,
        ...deliverRouter,
        ...selllackRouter,
        ...baddebtRouter,
        ...makeinvoiceRouter,
        ...maintaincostRouter,
        ...salesreturnRouter,
        ...returnoverlimltRouter,
        ...supplierRechargeRouter,
        ...customerdepositRouter,
        ...customershiftRouter,
        ...starleveladjustRouter,
        ...customerliftRouter,
        ...baliorRouter,
        ...customerbalanadjustRouter,
        ...supplieraccountadjustRouter,
        ...supplierdeductionadjustRouter,
        ...supplierreceiptRouter,
        ...ticketreceiptRouter
      ]
    }
  ]
}
